import React from "react";
import {Outlet, RouteProps} from "react-router-dom";
import {useLocation} from "react-router";
import {useViewController} from "data/services/locator";
import {IAuthController} from "views/controllers/auth/auth.controller";
import {observer} from "mobx-react";
import {Bindings} from "data/constants/bindings";
import {GAME_ZONE_URL} from "data/constants/routing";

/**
 * Set redirect uri, to return back after landing.
 */
export const getUri = (redirectUri: string) =>
	redirectUri ? `login?redirectUri=${redirectUri}` : `login`;

export const PrivateRoute: React.FC<RouteProps> = observer(() => {
	const {isAuthorized, didRequestRorUser} = useViewController<IAuthController>(
		Bindings.AuthController
	);
	const location = useLocation();

	if (isAuthorized) {
		return <Outlet />;
	}

	if (didRequestRorUser) {
		window.location.href = `${GAME_ZONE_URL}${getUri(location.pathname)}`;
	}

	return null;
});
